var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "yqg-indicator",
    style: _vm.style,
    on: {
      transitionend: function ($event) {
        return _vm.onTransitionEnd()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }